import { Button, Divider, Typography } from 'ui';
import { ExistingWidgetsTable } from 'components/consumer-page-widgets/ExistingWidgetsTable';
import { StoreType } from 'utils/connect';
import { Theme, css } from '@emotion/react';
import {
  WidgetTypeCases,
  WidgetTypeSelect,
  widgetTypeToDisplayNameMapping,
} from 'components/consumer-page-widgets/WidgetTypeSelect';
import { consumer } from '@tock/coretypes';
import { fetchAllNamedConfigurations, updateNamedConfiguration } from 'actions/ConsumerPageActions';
import { useAppDispatch } from 'state/hooks';
import { useSelector } from 'react-redux';
import AnchorV2 from 'components/AnchorV2';
import ClowncarBody from 'components/ClowncarBody';
import ClowncarHeader from 'components/ClowncarHeader';
import React, { FunctionComponent } from 'react';

const consumerPageWidgetsSelectField = ({ spacing }: Theme) => css`
  margin-top: ${spacing(2.5)};
`;

const consumerPageWidgetsDivider = ({ spacing }: Theme) => css`
  margin-top: ${spacing(2.5)};
  margin-bottom: ${spacing(2.5)};
`;

const consumerPageWidgetsCreateButton = ({ spacing }: Theme) => css`
  margin-bottom: ${spacing(5)};
`;

const consumerPageExistingWidgetsHeading = ({ spacing }: Theme) => css`
  margin-top: ${spacing(5)};
`;

export const ConsumerPageWidgetsHomeRoute: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const [selectedWidgetType, setSelectedWidgetType] =
    React.useState<WidgetTypeCases>('cardLinkWidgetConfig');

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(fetchAllNamedConfigurations());
  }, [dispatch]);

  const activeNamedConfigs = useSelector(
    (state: StoreType) => state.consumerPage.namedConfigurations
  ) as consumer.NamedConfiguration[]; // TODO: Fix types on consumerPage state slice

  const widgetsFilteredForSelectedType = activeNamedConfigs.filter((config) => {
    if (config.namedConfigurationConfig === 'gridWidgetConfig') {
      if (selectedWidgetType === 'carouselWidgetConfig') {
        return config.gridWidgetConfig?.displayType === 'CAROUSEL';
      }
      if (selectedWidgetType === 'gridWidgetConfig') {
        return config.gridWidgetConfig?.displayType !== 'CAROUSEL';
      }
    }
    return config.namedConfigurationConfig === selectedWidgetType;
  });

  const handleChangeWidgetType = (type: WidgetTypeCases) => setSelectedWidgetType(type);

  const archiveNamedConfiguration = (id: number) => {
    const configToArchive = widgetsFilteredForSelectedType.find((config) => config.id === id);

    dispatch(updateNamedConfiguration({ ...configToArchive, isArchived: true }));
    dispatch(fetchAllNamedConfigurations());
  };

  return (
    <div className="Content">
      <ClowncarHeader heading="Consumer page widgets" />
      <div className="Main">
        <ClowncarBody>
          <div css={consumerPageWidgetsSelectField}>
            <WidgetTypeSelect
              selectedWidgetType={selectedWidgetType}
              onChangeType={handleChangeWidgetType}
            />
          </div>
          <Divider css={consumerPageWidgetsDivider} />
          <Button
            component={AnchorV2}
            css={consumerPageWidgetsCreateButton}
            href="/tock/consumer-page-widgets/new"
          >
            Create new widget
          </Button>

          <Typography css={consumerPageExistingWidgetsHeading} variant="heading1Bold" mb={2}>
            Existing {widgetTypeToDisplayNameMapping[selectedWidgetType]}s
          </Typography>
          <ExistingWidgetsTable
            widgets={widgetsFilteredForSelectedType}
            onArchiveWidget={archiveNamedConfiguration}
          />
        </ClowncarBody>
      </div>
    </div>
  );
};
